export const CulturalList = [
    {
        id:1,
        title:"Uttarayani 2026",
        folderTitle:"/cultural/uttarayani2026/",
        images:["1.jpeg","2.jpeg","3.jpeg","4.jpeg","5.jpeg",]
    },
    {
        id:2,
        title:"Vasant Panchami 2026",
        folderTitle:"/cultural/vasantpanchmi2026/",
        images:["2.jpg","1.jpg","3.jpg","4.jpg"]
    },
    {
        id:3,
        title:"Parakram Diwas 2026",
        folderTitle:"/cultural/parakramdiwas2026/",
        images:["2.jpg","1.jpg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg"]
    },
     {
        id:4,
        title:"Republic Day Celebration 2026",
        folderTitle:"/cultural/republic2026/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","6.jpg"]
    },
     {
        id:5,
        title:"Durga Pooja 2025",
        folderTitle:"/cultural/durgapooja2025/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg","11.jpg"]
    },
        {
        id:6,
        title:"Talent Hunt 2025",
        folderTitle:"/cultural/childrenday2025/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg","11.jpg","12.jpg","13.jpg"]
    },
     {
        id:7,
        title:"Uttarakhand Establishment Day 2025",
        folderTitle:"/cultural/uttrakhanddiwas2025/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg","11.jpg"]
    },
    {
        id:8,
        title:"Guru Nanak Jayanti 2025",
        folderTitle:"/cultural/gnj2025/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg","11.jpg"]
    },
     {
        id:9,
        title:"National Unity Day 2025",
        folderTitle:"/cultural/unity2025/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg","11.jpg","12.jpg","13.jpg","14.jpg","15.jpg","16,jpg"]
    },
     {
        id:10,
        title:"Chhath Puja Celebration 2025",
        folderTitle:"/cultural/cpc2025/",
        images:["1.jpg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg"]
    },
      {
        id:11,
        title:"Diwali Celebration 2025",
        folderTitle:"/cultural/diwali2025/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg",
                "11.jpg","12.jpg","13.jpg","14.jpg","15.jpg","16.jpg","17.jpg","18.jpg","19.jpg","20.jpg",
                "21.jpg","22.jpg","23.jpg","24.jpg","25.jpg"
        ]
    },
    {
        id:12,
        title:"Navratri Celebration 2025",
        folderTitle:"/cultural/navratri2025/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg",
                "11.jpg"
        ]
    },
       {
        id:13,
        title:"Vishwakarma Pooja Celebration 2025",
        folderTitle:"/cultural/vpc2025/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg"]
    },
    {
        id:14,
        title:"Teachers Day Celebration 2025",
        folderTitle:"/cultural/tdc2025/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg",
             "11.jpg","12.jpg","13.jpg","14.jpg","15.jpg","16.jpg","17.jpg","18.jpg","19.jpg","20.jpg",
                "21.jpg","22.jpg","23.jpg","24.jpg","25.jpg","26.jpg","27.jpg","30.jpg",
                "31.jpg","32.jpg"
        ]
    },
    {
        id:15,
        title:"Handwriting Competition 2025",
        folderTitle:"/cultural/hc2025/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg",
        ]
    },
     {
        id:16,
        title:"Ganesh Chaturthi 2025",
        folderTitle:"/cultural/gc2025/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg",
        ]
    },
      {
        id:17,
        title:"Krishna Janmashtmi Celebration 2025",
        folderTitle:"/cultural/kj2025/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg",
            "11.jpg","12.jpg","13.jpg","14.jpg"
        ]
    },
    {
        id:18,
        title:"Raksha Bandhan Celebration 2025",
        folderTitle:"/cultural/rbc2025/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg",
            "11.jpg","12.jpg","13.jpg","14.jpg","15.jpg","16.jpg","17.jpg","18.jpg","19.jpg","20.jpg",
        ]
    },
     {
        id:19,
        title:"Kargil Vijay Diwas Activity 2025",
        folderTitle:"/cultural/kvd2025/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg",
            "11.jpg"
        ]
    },
       {
        id:20,
        title:"Harela Celebration 2025",
        folderTitle:"/cultural/harela2025/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg",
        ]
    },
     
     
     
     
     

]